import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import "./index.scss";

Vue.use(BootstrapVue);
